import cssVariables from 'tfs.css-variables'

export default {
  footer: {
    width: '100%',
    padding: '1rem',
    position: 'absolute',
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    fontSize: '0.8rem',
    color: cssVariables.colorGrayC,
  },
}
